import * as Yup from 'yup';

export default (t) => [
  Yup.object()
    .shape({
      streetName: Yup.string()
        .required(t('form.error.required')),
      houseNumber: Yup.string()
        .required(t('form.error.required')),
      postcode: Yup.string()
        .required(t('form.error.required')),
      location: Yup.string()
        .required(t('form.error.required')),
    }),

  Yup.object()
    .shape({
      subject0: Yup.string() // See if we can REGEX
        .notOneOf(['default'], t('form.error.required'))
        .required(t('form.error.required')),
      description: Yup.string()
        .required(t('form.error.required')),
    }),

  Yup.object()
    .shape({
      fullName: Yup.string()
        .required(t('form.error.required')),
      termsConditions: Yup.boolean().oneOf([true], t('form.error.required')).required(t('form.error.required')),
      emailAddress: Yup.string()
        .when('phoneNumber', {
          is: (phoneNumber) => !phoneNumber || phoneNumber.length === 0,
          then: Yup.string().email('formError.emailFormat').required(t('form.error.required')),
          otherwise: Yup.string(),
        }),
      phoneNumber: Yup.string()
        .when('emailAddress', {
          is: (emailAddress) => !emailAddress || emailAddress.length === 0,
          then: Yup.string().required(t('form.error.required')),
          otherwise: Yup.string(),
        }),
    }, ['emailAddress', 'phoneNumber']),
];
